export const actionTypes: any = {
  GET_LOAN_ELIGIBILITY_REPORT_START: 'GET_LOAN_ELIGIBILITY_REPORT_START',
  GET_LOAN_ELIGIBILITY_REPORT_SUCCESS: 'GET_LOAN_ELIGIBILITY_REPORT_SUCCESS',
  GET_LOAN_ELIGIBILITY_REPORT_FINISH: 'GET_LOAN_ELIGIBILITY_REPORT_FINISH',
}
